import { HttpClient } from '#client/http/index'
import { bindMethods } from '#client/utils/bindMethods'
import { Methods } from '#utils/typeUtils'
import { SegmentedClientInterface } from '../SegmentedClientInterface'
import * as user from './user/methods'

export class AuthClient implements SegmentedClientInterface {
  #user: Methods<typeof user>

  constructor(httpClient: HttpClient) {
    this.#user = bindMethods(this, { httpClient }, { user })
  }

  get prefix() {
    return 'auth'
  }

  get user() {
    return this.#user
  }
}
